import LeadListTable from "components/pageSection/LeadList/LeadListTable";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Wrapper } from "./CustomerList.styled";
import {
  Input,
  Row,
  Pagination,
  Col,
  Button,
  Select_,
  Loading,
  Radio,
  Drawer,
  Empty,
  Space,
  DatePicker,
} from "components/common";
import LeadListCard from "components/pageSection/LeadList/LeadListCard";

import { callGetApi, callPostApi } from "utils/api";
import { useHistory } from "react-router";
import { getUser } from "utils/auth";
import { useDebounce } from "use-debounce";
import { getUserPermissions } from "utils/text";
import moment from "moment/moment.js";
import { CheckOutlined } from "@ant-design/icons";
import CustomerListCard from "components/pageSection/CustomerList/CustomerListCard";

let timer;

var isAllowedToSet = true;

const CustomerList = () => {
  const history = useHistory();
  const [sortBy, setSortBy] = useState("");
  const [status, setStatus] = useState([]);
  const [leads, setLeads] = useState([]);
  const [duplicateLeads, setDuplicateLeads] = useState([]);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [filterStatus, setFilterStatus] = useState([]);
  const [filterUser, setFilterUser] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState();
  const [searchKeywordDebounce] = useDebounce(searchKeyword, 1000);
  const [buttonvalue, setButtonValue] = useState("All");
  const [appbuttonvalue, setappButtonValue] = useState("All");
  const [filterLeads, setFilterLead] = useState([]);
  const [cards, setCards] = useState(false);
  const [isInitialRender, setInitialRender] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [dateLeads, setDateLeads] = useState([]);
  const [projectCounts, setProjectCounts] = useState({
    AC: [],
    CON: [],
    SS: [],
    INSTALL: [],
    PTO: [],
    CANCEL: [],
  });
  const [btnStatus, setBtnStatus] = useState("AC");
  // const [size, setSize] = useState();
  const [datePick, setDatePick] = useState("");
  const [currentpage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [pageData, setPageData] = useState([]);

  //sorting For Project AC CON

  const showDefaultDrawer = () => {
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
  };
  const OpenDrawer = () => {
    setIsOpen(true);
  };

  const SuccessAppointmentsCall = (data) => {
    setStatus(data.map((e) => ({ id: e._id, name: e.name })));
  };

  const FailAppointmentCall = (err) => { };

  const SuccessUsersCall = (data) => {
    setUsers(data.map((e) => ({ id: e._id, name: e.username })));
  };

  const FailUsersCall = (err) => { };

  const SuccessLeadsCall = (data) => {
    setLeads(data?.hits);
    setFilterLead(data?.hits);
    setIsLoading(false);
  };

  const FailLeadsCall = (err) => {
    setIsLoading(false);
  };

  const changeStatus = (e) => {
    setSortBy("");
    setInitialRender(true);
    isAllowedToSet = true;
    console.log("rrrrrr", e);
    setFilterStatus(e);
    const params = {};
    if (e?.length > 0) {
      params.statusFilters = e;
    }
    if (filterUser?.length > 0) {
      params.userFilters = filterUser;
    }
    if (searchKeyword) {
      params.leadInput = searchKeyword;
    }
    callPostApi('/leads/get', params, SuccessFilterCall, FailFilterCall);
  };

  const changeUser = (e) => {
    setSortBy("");
    setInitialRender(true);
    isAllowedToSet = true;
    setFilterUser(e);
    const params = {};
    if (filterStatus?.length > 0) {
      params.statusFilters = filterStatus;
    }
    if (e?.length > 0) {
      params.userFilters = e;
    }
    if (searchKeyword) {
      params.leadInput = searchKeyword;
    }
    callPostApi('/leads/get', params, SuccessFilterCall, FailFilterCall);
  };

  //Filter Depend ON AC, CON
  const onHandleProjectValues = (e) => {
    console.log(datePick);
    setSortBy("");
    if (datePick) {
      if (e.target.value === "AC") {
        setBtnStatus(e.target.value);
        setLeads(dateLeads);
      } else if (e.target.value === "CON") {
        setBtnStatus(e.target.value);
        let conArray = [];
        let ls = [...dateLeads];
        ls.filter((el) =>
          el.created && el?.created !== "" && el.created !== null
            ? conArray.push(el)
            : ""
        );
        setLeads(conArray);
      } else if (e.target.value === "SS") {
        setBtnStatus(e.target.value);
        let SSArray = [];
        let ls = [...dateLeads];
        ls.filter((el) =>
          el.m1 && el?.m1 !== "" && el.m1 !== null ? SSArray.push(el) : ""
        );
        setLeads(SSArray);
      } else if (e.target.value === "Install") {
        setBtnStatus(e.target.value);
        let installArray = [];
        let ls = [...dateLeads];
        ls.filter((el) =>
          el.m2 && el?.m2 !== "" && el.m2 !== null ? installArray.push(el) : ""
        );
        setLeads(installArray);
      } else if (e.target.value === "PTO") {
        setBtnStatus(e.target.value);
        let ls = [...dateLeads];
        let ptoArray = [];
        ls.filter((el) =>
          el.ptoDate && el?.ptoDate !== "" && el.ptoDate !== null
            ? ptoArray.push(el)
            : ""
        );
        setLeads(ptoArray);
      } else {
        let ls = [...dateLeads];
        setBtnStatus(e.target.value);
        let cancelArray = [];
        ls.filter((el) =>
          el.date_cancelled &&
            el?.date_cancelled !== "" &&
            el.date_cancelled !== null
            ? cancelArray.push(el)
            : ""
        );
        setLeads(cancelArray);
      }
    } else {
      if (e.target.value === "AC") {
        setBtnStatus(e.target.value);
        setLeads(duplicateLeads);
      } else if (e.target.value === "CON") {
        setBtnStatus(e.target.value);
        let conArray = [];
        let ls = [...duplicateLeads];
        ls.filter((el) =>
          el.created && el?.created !== "" && el.created !== null
            ? conArray.push(el)
            : ""
        );

        setLeads(conArray);
      } else if (e.target.value === "SS") {
        setBtnStatus(e.target.value);
        let SSArray = [];
        let ls = [...duplicateLeads];
        ls.filter((el) =>
          el.m1 && el?.m1 !== "" && el.m1 !== null ? SSArray.push(el) : ""
        );
        setLeads(SSArray);
      } else if (e.target.value === "Install") {
        setBtnStatus(e.target.value);
        let installArray = [];
        let ls = [...duplicateLeads];
        console.log("For count ls", ls);
        ls.filter((el) =>
          el.m2 && el?.m2 !== "" && el.m2 !== null ? installArray.push(el) : ""
        );
        setLeads(installArray);
      } else if (e.target.value === "PTO") {
        setBtnStatus(e.target.value);
        let ls = [...duplicateLeads];
        let ptoArray = [];
        ls.filter((el) =>
          el.ptoDate && el?.ptoDate !== "" && el.ptoDate !== null
            ? ptoArray.push(el)
            : ""
        );
        setLeads(ptoArray);
      } else {
        let ls = [...duplicateLeads];
        setBtnStatus(e.target.value);
        let cancelArray = [];
        ls.filter((el) =>
          el.date_cancelled &&
            el?.date_cancelled !== "" &&
            el.date_cancelled !== null
            ? cancelArray.push(el)
            : ""
        );
        setLeads(cancelArray);
      }
    }
  };

  //get Project Values
  const getProjectValues = (leads) => {
    console.log(leads.length, "AC");
    let conArray = [];
    leads.filter((el) =>
      el.created && el?.created !== "" && el.created !== null
        ? conArray.push(el)
        : ""
    );
    let SSArray = [];
    leads.filter((el) =>
      el.m1 && el?.m1 !== "" && el.m1 !== null ? SSArray.push(el) : ""
    );
    let installArray = [];
    console.log("For count", leads);
    leads.filter((el) =>
      el.m2 && el?.m2 !== "" && el.m2 !== null ? installArray.push(el) : ""
    );
    let ptoArray = [];
    leads.filter((el) =>
      el.ptoDate && el?.ptoDate !== "" && el.ptoDate !== null
        ? ptoArray.push(el)
        : ""
    );
    let cancelArray = [];
    leads.filter((el) =>
      el.date_cancelled &&
        el?.date_cancelled !== "" &&
        el.date_cancelled !== null
        ? cancelArray.push(el)
        : ""
    );
    console.log(projectCounts.AC?.length);
    setProjectCounts({
      ...projectCounts,
      AC: leads,
      CON: conArray,
      INSTALL: installArray,
      PTO: ptoArray,
      CANCEL: cancelArray,
      SS: SSArray,
    });
  };
  const SuccessFilterCall = (data) => {
    if (isAllowedToSet) {
      let leads_ = [];
      data?.hits?.map((li) => {
        let statusName = data?.allApptOutcomes?.filter(
          (el) => el.id == li.status
        )?.[0]?.name;
        leads_?.push({
          ...li,
          statusName: statusName || "ccc",
        });
      });
      if (datePick) {
        console.log("Status");
        let ls = [...leads_];
        let arry = [];
        ls.filter((el) =>
          el?.dateCreated && new Date(el?.dateCreated) >= new Date(datePick)
            ? arry.push(el)
            : console.log("Done")
        );
        let aar1 = [];
        arry.filter((el) =>
          el.status === filterStatus[0] ? aar1.push(el) : ""
        );
        filterUser.map((val) => {
          arry.filter((el) => (el.objectID === val ? data.push(val) : ""));
        })
        console.log("rrrrrrffff", filterStatus);

        console.log(arry);
        isAllowedToSet = true;
        setInitialRender(false);
        setLeads(aar1);
        setDateLeads(aar1);

        getProjectValues(aar1);
        // setDuplicateLeads(leads_);
        // setFilterLead(leads_);
        setIsLoading(false);
        setDisable(false);
        setPageData(data);
      } else {
        let data = [];
        filterStatus.map((val) => {
          leads_.filter((el) => (el.status === val ? data.push(val) : ""));
        });
        filterUser.map((val) => {
          data.filter((el) => (el.objectID === val ? data.push(val) : ""));
        })
        console.log("ddd", data);
        isAllowedToSet = true;
        setInitialRender(false);
        setLeads(leads_);
        getProjectValues(leads_);
        setDuplicateLeads(leads_);
        setFilterLead(leads_);
        setIsLoading(false);
        setDisable(false);
        setPageData(data);
      }
    }
  };
  const FailFilterCall = (err) => {
    setIsLoading(false);
  };

  const handleSearchKeywordChange = (e) => {
    isAllowedToSet = true;
    setInitialRender(true);
    setSearchKeyword(e.target.value);
    setSortBy("");
  };

  function callApiForLead(currentpage_) {
    setIsLoading(true);
    const params = {};
    if (filterStatus?.length > 0) {
      params.statusFilters = filterStatus;
    }
    if (filterUser?.length > 0) {
      params.userFilters = filterUser;
    }
    if (searchKeyword) {
      params.leadInput = searchKeyword;
    }

    callPostApi('/leads/get', params, SuccessFilterCall, FailFilterCall);
  }

  useEffect(() => {
    callApiForLead();
  }, [searchKeywordDebounce]);

  const handleFilter = (e) => {
    setIsLoading(true);
  };

  const getApi = () => {
    callGetApi(
      "/appointment",
      SuccessAppointmentsCall,
      FailAppointmentCall
    );
    callGetApi("/user", SuccessUsersCall, FailUsersCall);
  };

  useEffect(() => {
    getApi();
    setIsLoading(true);
  }, []);

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 1500) {
        setCards(true);
      } else {
        return setCards(false);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    if (sortBy) {
      if (sortBy == "status") {
        let dLeads = [...leads];
        setLeads([...dLeads.sort((a, b) => a?.statusName - b?.statusName)]);
        setLeads([
          ...dLeads.sort((a, b) => {
            if (a?.statusName > b?.statusName) {
              return 1;
            } else if (a?.statusName < b?.statusName) {
              return -1;
            } else {
              return 0;
            }
          }),
        ]);
      } else if (sortBy == "name") {
        let dLeads = [...leads];
        setLeads([
          ...dLeads.sort((a, b) => {
            let aFirstName = a?.setter?.name.split(" ")[0];
            let bFirstName = b?.setter?.name.split(" ")[0];
            let aLastName = b?.setter?.name.split(" ")[1];
            let bLastName = b?.setter?.name.split(" ")[1];
            if (aFirstName > bFirstName) {
              return 1;
            } else if (aFirstName < bFirstName) {
              return -1;
            }

            if (aLastName > b.lastName) {
              return 1;
            } else if (aLastName < b.lastName) {
              return -1;
            } else {
              return 0;
            }
          }),
        ]);
        setLeads([...dLeads.sort((a, b) => a?.setter?.name - b?.setter?.name)]);
      } else if (sortBy == "dateCreated") {
        let dLeads = [...leads];
        setLeads([
          ...dLeads.sort((a, b) => {
            if (a?.dateCreated > b?.dateCreated) {
              return -1;
            }
            if (a?.dateCreated < b?.dateCreated) {
              return 1;
            }
            return 0;
          }),
        ]);
      } else if (sortBy == "appointmentTime") {
        let dLeads = [...leads];
        setLeads([
          ...dLeads.sort((a, b) => {
            if (a?.appointmentTime > b?.appointmentTime) {
              return -1;
            }
            if (a?.appointmentTime < b?.appointmentTime) {
              return 1;
            }
            return 0;
          }),
        ]);
      } else if (sortBy == "street") {
        let dLeads = [...leads];
        setLeads([
          ...dLeads.sort((a, b) => {
            if (a?.street > b?.street) {
              return 1;
            }
            if (a?.street < b?.street) {
              return -1;
            }
            return 0;
          }),
        ]);
      } else if (sortBy == "firstName") {
        let dLeads = [...leads];
        setLeads([
          ...dLeads.sort((a, b) => {
            if (a?.firstName > b?.firstName) {
              return 1;
            } else if (a?.firstName < b?.firstName) {
              return -1;
            }
            if (a.lastName > b.lastName) {
              return 1;
            } else if (a.lastName < b.lastName) {
              return -1;
            }
            return 0;
          }),
        ]);
      }
    }
  }, [sortBy]);
  const callApiWithPagination = (el) => {
    // isAllowedToSet = true;
    // callApiForLead(el?.current);
  };

  const onChange = (date, dateString) => { };

  useEffect(() => {
    if (datePick !== "" && datePick !== null) {
      let ls = [...leads];
      let arry = [];
      ls.filter((el) =>
        el?.dateCreated && new Date(el?.dateCreated) >= new Date(datePick)
          ? arry.push(el)
          : console.log("Done")
      );
      console.log("Date Length", arry.length);
      setLeads(arry);
      setDateLeads(arry);
      getProjectValues(arry);
    } else {
      console.log("Yes Call");

      // let ls = [...duplicateLeads];
      // let data = [];
      // filterStatus.map((val) => {
      //   ls.filter((el) => (el.status === val ? data.push(el) : ""));
      // });
      // console.log(data)
      setLeads(duplicateLeads);
      getProjectValues(duplicateLeads);
    }
  }, [datePick]);

  return (
    <Wrapper>
      <div className="search-container">
        <Row gutter={[15, 15]} className="search-row">
          <Col xs={24} sm={24} lg={16} xl={16} xxl={16}>
            <Input
              placeholder="Search..."
              className="search-box"
              onChange={handleSearchKeywordChange}
            />
          </Col>
          <Col xs={24} sm={24} lg={8} xl={8} xxl={8}>
            {getUserPermissions("add-lead-action") && (
              <Button
                title="Add Lead"
                className="search-button"
                onClick={() => {
                  history.push("/lead-form");
                }}
              />
            )}
          </Col>

          <Col xs={24} sm={24} lg={24} xl={12} xxl={12}>
            <Select_
              placeholder="Select Status"
              button
              buttonTitle="Filter"
              options={status}
              mode="multiple"
              onChange={changeStatus}
              name
              showSearch
              onSelect={handleFilter}
              onDeselect={handleFilter}
            />
          </Col>

          {getUserPermissions("select-rep-view-action") && (
            <Col xs={24} sm={24} lg={24} xl={12} xxl={12}>
              <Select_
                placeholder="Select Reps"
                button
                buttonTitle="Filter"
                options={users}
                mode="multiple"
                onChange={changeUser}
                name
                onSelect={handleFilter}
                onDeselect={handleFilter}
              />
            </Col>
          )}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Row gutter={[0, 10]}>
              <Col className="appoinment-buttons">
                <Radio.Group value={btnStatus} onChange={onHandleProjectValues}>
                  <Radio.Button value="AC">
                    <Row
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "row",
                      }}
                    >
                      <Col span={24}>AC {projectCounts?.AC.length}</Col>
                    </Row>
                  </Radio.Button>
                  <Radio.Button value="CON">
                    <Row
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Col>CON {projectCounts?.CON.length}</Col>
                    </Row>
                  </Radio.Button>
                  <Radio.Button value="SS">
                    <Row
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Col>SS {projectCounts?.SS.length}</Col>
                    </Row>
                  </Radio.Button>
                  <Radio.Button value="Install">
                    <Row
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Col>Install {projectCounts?.INSTALL?.length}</Col>
                    </Row>
                  </Radio.Button>
                  <Radio.Button value="PTO">
                    <Row
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Col>PTO {projectCounts?.PTO.length}</Col>
                    </Row>
                  </Radio.Button>
                  <Radio.Button value="Cancelled">
                    <Row
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Col>Cancelled {projectCounts?.CANCEL?.length}</Col>
                    </Row>
                  </Radio.Button>
                </Radio.Group>
              </Col>
            </Row>

            {getUserPermissions("created-after-date-view") && (
              <>
                <Col
                  style={{ display: "flex", justifyContent: "center" }}
                  xs={24}
                  sm={6}
                  lg={6}
                  xl={4}
                  xxl={6}
                  className="appoinment-header-col"
                  id="Created-after-date"
                >
                  <p>Created After Date:</p>
                </Col>
                <Col
                  xs={24}
                  sm={6}
                  lg={6}
                  xl={4}
                  xxl={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <DatePicker
                    onChange={(e) => {
                      if (e) {
                        setDatePick(moment(e).format("YYYY-MM-DD"));
                      } else if (e === null) {
                        setDatePick(null);
                      }
                    }}
                    picker="date"
                  />
                </Col>
              </>
            )}
          </div>
        </Row>
      </div>
      {cards ? (
        isLoading ? (
          <Loading />
        ) : (
          <div>
            {leads.length == 0 ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <Empty />
              </div>
            ) : (
              <CustomerListCard
                data={leads}
                date={[]}
                isLoading={isLoading}
                status={status}
                showDefaultDrawer={showDefaultDrawer}
              />
            )}

            {/* <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Pagination
                total={pageData?.totalLead}
                showSizeChanger
                current={pageData?.currentPage}
                pageSize={10}
                onChange={(el) => {
                  callApiWithPagination({
                    current: el,
                  });
                }}
              />
            </div> */}
          </div>
        )
      ) : (
        <LeadListTable
          data={leads}
          isLoading={isLoading}
          status={status}
        // pageData={pageData}
        // callApiWithPagination={callApiWithPagination}
        />
      )}

      <Drawer
        title="Sort Leads By."
        placement="bottom"
        className="bottom-drawer"
        onClose={() => {
          setIsOpen(false);
        }}
        visible={isOpen}
      >
        <div style={{ padding: "15px" }}>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <p
                    className="label"
                    onClick={() => {
                      setSortBy("firstName");
                      setIsOpen(false);
                    }}
                    style={{
                      fontWeight: sortBy == "firstName" ? "bold" : "normal",
                    }}
                  >
                    Name
                    {sortBy == "firstName" && (
                      <CheckOutlined
                        style={{
                          color: "green",
                          float: "right",
                        }}
                      />
                    )}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <p
                    className="label"
                    onClick={() => {
                      setSortBy("street");
                      setIsOpen(false);
                    }}
                    style={{
                      fontWeight: sortBy == "street" ? "bold" : "normal",
                    }}
                  >
                    Address
                    {sortBy == "street" && (
                      <CheckOutlined
                        style={{
                          color: "green",
                          float: "right",
                        }}
                      />
                    )}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <p
                    className="label"
                    onClick={() => {
                      setSortBy("appointmentTime");
                      setIsOpen(false);
                    }}
                    style={{
                      fontWeight:
                        sortBy == "appointmentTime" ? "bold" : "normal",
                    }}
                  >
                    Appointment Time
                    {sortBy == "appointmentTime" && (
                      <CheckOutlined
                        style={{
                          color: "green",
                          float: "right",
                        }}
                      />
                    )}
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Drawer>
    </Wrapper>
  );
};

export default CustomerList;
